import axiosInstance from "@/utils/axios";

export const chatApi = {
  // Staff Endpoints
  getConversations: () =>
    axiosInstance.get("/api/chat/conversations"),

  getHistory: ({ conversationId, guestSessionId, targetUserId, targetDepartment, skip = 0, take = 50 }) =>
    axiosInstance.get("/api/chat/history", {
      params: { conversationId, guestSessionId, targetUserId, targetDepartment, skip, take }
    }),

  sendMessage: (payload) =>
    axiosInstance.post("/api/chat/send", payload),

  markAsRead: (payload) =>
    axiosInstance.post("/api/chat/read", payload),

  getUnreadCount: () =>
    axiosInstance.get("/api/chat/unread-count"),

  getDirectory: () =>
    axiosInstance.get("/api/chat/directory"),

  // Guest Endpoints
  getGuestConversation: ({ organizationId, guestSessionId, department, guestName, roomName }) =>
    axiosInstance.get("/api/guest-chat/conversation", {
      params: { organizationId, guestSessionId, department, guestName, roomName }
    }),

  getGuestHistory: ({ organizationId, guestSessionId, conversationId, skip = 0, take = 50 }) =>
    axiosInstance.get("/api/guest-chat/history", {
      params: { organizationId, guestSessionId, conversationId, skip, take }
    }),

  sendGuestMessage: (payload) =>
    axiosInstance.post("/api/guest-chat/send", payload),

  markGuestAsRead: ({ organizationId, guestSessionId, conversationId }) =>
    axiosInstance.post("/api/guest-chat/read", { conversationId, guestSessionId }, {
      params: { organizationId, guestSessionId }
    }),

  getGuestUnreadCount: ({ organizationId, guestSessionId }) =>
    axiosInstance.get("/api/guest-chat/unread-count", {
      params: { organizationId, guestSessionId }
    }),
};
